import { Icon } from '@ui/themed';
import type { IconName } from '../../../components/ui/icon/types';

/**
 * A platform tinted tile wrapping a single icon
 */
export function FeatureIconTile({ icon }: { icon: IconName }) {
  return (
    <span className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-black/15 bg-platform-primary/10 text-platform-primary">
      <Icon name={icon} size="md" />
    </span>
  );
}
